<template>
  <div class="container">
    <a-form
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 10 }"
    >
      <a-form-item
        label="业务流水号"
        has-feedback
      >
        <span>{{ dataSourceInfo.applyNo }}</span>
      </a-form-item>
      <a-form-item
        label="投保申请数据"
        has-feedback
      >
        <span class="no-wrap">{{ dataSourceInfo.applyData }}</span>
      </a-form-item>
      <a-form-item
        label="数字信封加密"
        has-feedback
      >
        <span class="no-wrap">{{ dataSourceInfo.digitalEnvelope }}</span>
      </a-form-item>
      <a-button
        type="primary"
        size="large"
        class="btnCA"
        @click="btnCA"
      >
        CA锁解密
      </a-button>
      <a-button
        type="primary"
        size="large"
        class="btnBX"
        @click="btnBX"
      >
        标证通解密
      </a-button>
    </a-form>
    <a-modal
      class="rules"
      v-model="tipShow"
      title=""
      centered
      :mask-closable="false"
    >
      <img
        id="guangzhengQrcodeImage"
        alt="code"
        v-show="qrcodeImageShow"
      >
      <template v-slot:footer />
    </a-modal>
  </div>
</template>

<script>
/* global iWebNet, ThrowEx, QRCode */
import apis from '@/api/insurePreGuangZheng.js';
const {
  buildGuangzhengRequestData,
  buildBztQrcodeParams,
  buildBztQueryParams,
  extractBztQrContent,
  decryptWithLocalOcx,
  decryptEnvelopeWithFallback,
} = require('./decryptors');
function GuangzhengEpCaObj(breakOnError) {
  if (breakOnError && !this.CAInit()) {
    ThrowEx('CA证书读取异常,请先插好CA锁!');
  }
}
GuangzhengEpCaObj.prototype.CAType = '420';
GuangzhengEpCaObj.prototype.CAInit = function() {
  try {
    const initData = iWebNet.Prepare('CAInit');
    const initResult = iWebNet.PostMsg(initData);
    return initResult.body.qrstatus === '1';
  } catch (ex) {
    ThrowEx('请使用IE浏览器，并确保驱动已正确安装!');
  }
};
GuangzhengEpCaObj.prototype.Encrypt = function(OrgData) { try { const EncData = { body: { qrinfo: { ext: { CertPath: '' }, decryptobjects: [{ org: OrgData }], qrcodetype: 'Encrypt' } } }; const rtnVRRes = iWebNet.PostMsg(EncData); if (rtnVRRes !== '') { return rtnVRRes.body.qrinfo.decryptobjects[0].encryed; } return ''; } catch (ex) { ThrowEx('加密出现异常，请检查锁是否插好!'); } };
GuangzhengEpCaObj.prototype.Decrypt = function(JiaMiData) { try { const DecData = { body: { qrinfo: { decryptobjects: [{ encryed: JiaMiData }], qrcodetype: 'Decrypt' } } }; const rtnDec = iWebNet.PostMsg(DecData); if (rtnDec !== '') return rtnDec.body.qrinfo.decryptobjects[0].org; return ''; } catch (ex) { ThrowEx('解密过程出现异常，可能的原因：' + ex.description); } };
export default {
  name: 'InsurePreGuangZheng',
  components: {

  },
  data() {
    return {
      dataSourceInfo: {
        applyno: '',
      },
      qrcodeImageShow: false,
      qrcodeid: '',
      timer: null,
      tipShow: false,
    };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    decryptWithIWebNet(encryptedEnvelope) {
      iWebNet.Init(420);
      new GuangzhengEpCaObj(true);
      return GuangzhengEpCaObj.prototype.Decrypt(encryptedEnvelope);
    },
    async Inits() {
      const that = this;
      await apis.getPredata({ orderNo: this.$route.query.orderNo }).then(({ data: data }) => {
        that.dataSourceInfo = data;

      });
      try {
        const decryptedEnvelopeRaw = await decryptEnvelopeWithFallback(
          that.dataSourceInfo.digitalEnvelope,
          {
            localDecrypt: decryptWithLocalOcx,
            iwebDecrypt: encryptedEnvelope => this.decryptWithIWebNet(encryptedEnvelope),
          }
        );
        const requestData = buildGuangzhengRequestData(
          that.dataSourceInfo.applyNo,
          decryptedEnvelopeRaw
        );
        that.dataSourceInfo.digitalEnvelope = decryptedEnvelopeRaw;
        apis.postDigitalEnvelope({
          type: requestData.type,
          applyno: requestData.applyno,
          encryptkey: requestData.encryptkey,
        }).then(({ data: data }) => {
          window.location.href = data.redirectUrl;
        });
      } catch (error) {
        const message = error && error.message
          ? error.message
          : 'CA解密失败，请稍后重试';
        that.$notification.error({ message });
        return;
      }

    },
    btnCA() {
      this.Inits();

    },
    async btnBX() {
      const that = this;
      this.tipShow = true;
      await apis.getQrcode(buildBztQrcodeParams(this.$route.query.orderNo)).then(({ data: data }) => {
        this.qrcodeImageShow = true;
        const qrInfo = extractBztQrContent(data);
        that.qrcodeid = qrInfo.qrcodeid;
        const imageElement = document.getElementById('guangzhengQrcodeImage');
        QRCode.toDataURL(qrInfo.content, function(error, url) {
          if (error) {
            console.error(error);
          } else {
            imageElement.src = url;
            that.GetqueryResult();
          }
        });
      });
    },
    GetqueryResult() {
      const that = this;
      clearTimeout(that.timer);
      apis.getQueryResult(buildBztQueryParams(this.$route.query.orderNo, that.qrcodeid)).then(({ data: data }) => {
        if (data.toInsure === '1') {
          window.location.href = data.redirectUrl;
          return false;
        }
        if (data.qrstatus === '03') {
          that.tipShow = false;
          that.qrcodeImageShow = false;
        } else {
          that.timer = setTimeout(function() {
            that.GetqueryResult();
          }, 10000);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
}

.main {
  padding: 30px 50px 95px;
}

.pickCompany {
  margin-top: 90px;
}

.operate {
  margin-top: 80px;
}

.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
.no-wrap {
  word-wrap: break-word;
}
.btnCA{
  margin-top: 100px;
  margin-left: 380px;
}
.btnBX{
  margin-top: 100px;
  margin-left: 30px;
}
::v-deep .ant-modal {
  width: 960px !important;
}
::v-deep .ant-modal-content {
  width: 960px !important;
  height: 680px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}
::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}
::v-deep .ant-modal-header {
  border-bottom: none;
}
::v-deep .ant-modal-footer {
  border-top: none;
}
#guangzhengQrcodeImage{
  display: block;
  width: 360px;
  height: 360px;
  margin: 80px auto;
}
</style>
